import { ReactNode } from 'react';
import { SxProps } from '@mui/material';

import { Box } from '../../../Box';

type Props = {
  children: ReactNode;
};

const controlsStyles: SxProps = {
  padding: '12px 24px',
  display: 'flex',
  flexWrap: 'nowrap',
  gap: '12px',
  alignItems: 'center',
  justifyContent: 'flex-end',
  borderTop: '1px solid var(--color-general-grey-300)',
};

export const Controls = ({ children }: Props) => {
  return <Box sx={controlsStyles}>{children}</Box>;
};
